import { render } from "./AutorisationParentale.view.vue?vue&type=template&id=1b4664b6"
import script from "./AutorisationParentale.view.vue?vue&type=script&lang=js"
export * from "./AutorisationParentale.view.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__